import { render, staticRenderFns } from "./BillOfLadingEdit.vue?vue&type=template&id=f0e3808c&"
import script from "./BillOfLadingEdit.vue?vue&type=script&lang=js&"
export * from "./BillOfLadingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports